import { useState, useEffect } from 'react';
import { getFormOptions } from '../api';

export default (fields, excludeAllMailClassOption = false) => {
  const [loaded, updateLoaded] = useState(false);
  const [options, updateOptions] = useState({});

  async function fetchFields() {
    const response = await getFormOptions(fields);

    if (!response) {
      return;
    }

    fields.forEach((field) => {
      let propertyName;
      let customFieldName = field;
      switch (field) {
      case 'date_type':
        propertyName = 'dateType';
        break;
      case 'postal_operator':
        propertyName = 'operator';
        break;
      case 'carrier':
        propertyName = 'carrier';
        break;
      case 'dropdown_carrier':
        propertyName = 'carrier';
        customFieldName = 'carrier';
        break;
      case 'mail_class':
        propertyName = 'mailClass';
        break;
      case 'internal_carrier':
        propertyName = 'internalCarrier';
        break;
      case 'internal_postal_operator':
        propertyName = 'internalOperator';
        break;
      default:
        propertyName = field;
        break;
      }

      options[propertyName] = response[customFieldName];
    });
    if (options.impc === undefined) {
      options.impc = [];
    }
    if (excludeAllMailClassOption && options.mailClass && options.mailClass.length) {
      options.mailClass = options.mailClass.filter(item => item.value !== 'All');
    }

    updateOptions(options);
    updateLoaded(true);
  }

  useEffect(() => {
    fetchFields();
  }, []);

  return [options, loaded, updateOptions];
};
